import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { UNLOAD_SURVEY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { UnloadSurveyDataActionTypes } from './types';
import api from 'src/utils/api';

export const unloadSurvey =
  (
    id: number,
  ): ThunkAction<Promise<void>, State, null, UnloadSurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: UNLOAD_SURVEY + REQUEST });
    try {
      await api.unloadSurvey(id);
      dispatch({ type: UNLOAD_SURVEY + SUCCESS });
    } catch (error) {
      dispatch({ type: UNLOAD_SURVEY + FAILURE, error });
    }
  };

export const unloadSurveyIdle = () => ({ type: UNLOAD_SURVEY + IDLE });
